export type CartVoucherKind = 'RABATT' | 'PRODUKT' | 'PRODUKTGRUPPE' | 'SONDERPREIS';

/** Live-Runde 10: a voucher of the customer in the cart and the Kassa — redeemed (checked) or available. */
export default class CartVoucher {
    /** Absent on a guest's landing-page preview — that voucher comes with the registration. */
    public readonly code?: string;
    public readonly kind: CartVoucherKind;
    public readonly title: string;
    public readonly discountNet?: number;
    public readonly minTurnoverNet?: number;
    public readonly productNumber?: number;
    public readonly articleTypeId?: number;
    public readonly articleGroupId?: number;
    public readonly premiumLevel?: number;
    public readonly validTo?: string;
    public readonly selected: boolean;
    public readonly applied: boolean;
    public readonly preselected: boolean;
    public readonly notAppliedReason?: string;
    public readonly amountNet: number;
    public readonly amountGross: number;
    public readonly targetProductNumber?: number;
    public readonly discountPercent?: number;

    constructor(json: any) {
        this.code = json.code ?? undefined;
        this.kind = json.kind;
        this.title = json.title ?? '';
        this.discountNet = json.discountNet ?? undefined;
        this.minTurnoverNet = json.minTurnoverNet ?? undefined;
        this.productNumber = json.productNumber ?? undefined;
        this.articleTypeId = json.articleTypeId ?? undefined;
        this.articleGroupId = json.articleGroupId ?? undefined;
        this.premiumLevel = json.premiumLevel ?? undefined;
        this.validTo = json.validTo ?? undefined;
        this.selected = json.selected === true;
        this.applied = json.applied === true;
        this.preselected = json.preselected === true;
        this.notAppliedReason = json.notAppliedReason ?? undefined;
        this.amountNet = json.amountNet ?? 0;
        this.amountGross = json.amountGross ?? 0;
        this.targetProductNumber = json.targetProductNumber ?? undefined;
        this.discountPercent = json.discountPercent ?? undefined;
    }

    /** The discount granted in the cart's display mode (a positive figure). */
    public amountIn(gross: boolean): number {
        return gross ? this.amountGross : this.amountNet;
    }

    public get isFreePiece(): boolean {
        return this.kind === 'PRODUKT' || this.kind === 'PRODUKTGRUPPE';
    }
}
